import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTipofalla, getEquipomto, crearTicketmto } from '../../redux/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import PacmanLoader from 'react-spinners/PacmanLoader';
import styles from './GenerarTicket.module.css';
import { FaTools, FaPaperPlane } from 'react-icons/fa';

const MySwal = withReactContent(Swal);

const GenerarTicketmto = () => {
    const dispatch = useDispatch();
    const tipofalla = useSelector((state) => state.tipofalla);
    const equipos = useSelector((state) => state.equiposmto);
    const [codigo, setCodigo] = useState('');
    const [tipoFallaSeleccionado, setTipoFallaSeleccionado] = useState('');
    const [observaciones, setObservaciones] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [busquedaEquipo, setBusquedaEquipo] = useState('');
    const [equipoSeleccionado, setEquipoSeleccionado] = useState(null);
    const [otrafalla, setOtrafalla] = useState('');

    useEffect(() => {
        dispatch(getTipofalla());
    }, [dispatch]);

    useEffect(() => {
        dispatch(getEquipomto());
    }, [dispatch]);

    // Normalizar: el backend puede devolver objetos planos {id, cod, Nombrequipo}
    // o envueltos en { equipo: {id, cod, Nombrequipo} }
    const normalizeEquipo = (item) => item?.equipo || item;

    const equiposFiltrados = equipos.filter((item) => {
        const eq = normalizeEquipo(item);
        if (!eq?.cod && !eq?.Nombrequipo) return false;

        const texto = busquedaEquipo.toLowerCase().trim();
        const cod = String(eq.cod || '').toLowerCase();
        const nombre = String(eq.Nombrequipo || '').toLowerCase();

        return cod.includes(texto) || nombre.includes(texto);
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');

        if (!equipoSeleccionado) {
            setError('Debe seleccionar un equipo.');
            return;
        }

        const asignacionSeleccionada = {
            equipo: equipoSeleccionado
        };

        const usuarioData = JSON.parse(sessionStorage.getItem('usuario'));

        if (!usuarioData || !usuarioData.usuario || !usuarioData.usuario.nombre || !usuarioData.usuario.email) {
            setError('No se han encontrado los datos del usuario en la sesión.');
            return;
        }

        const nombreUsuario = usuarioData.usuario.nombre;
        const correoUsuario = usuarioData.usuario.email;
        const idUsuario = usuarioData.usuario.id;

        const nuevoTicket = {
            fecha: new Date().toISOString(),
            Observacion: observaciones,
            FallaId: tipoFallaSeleccionado,
            EstadoId: 1,
            EquipoId: asignacionSeleccionada.equipo.id,
            cod: asignacionSeleccionada.equipo.cod,
            nombreUsuario: nombreUsuario,
            correoUsuario: correoUsuario,
            Equiponombre: asignacionSeleccionada.equipo.Nombrequipo,
            UsuarioId: idUsuario,
            Otrafalla: otrafalla
        };

        setLoading(true);

        try {
            const resultAction = await dispatch(crearTicketmto(nuevoTicket));
            if (crearTicketmto.fulfilled.match(resultAction)) {
                const ticketId = resultAction.payload.Ticket.id;
                setTimeout(() => {
                    setLoading(false);
                    MySwal.fire({
                        title: 'Ticket Generado',
                        text: `Se ha generado su ticket con el número ${ticketId}`,
                        icon: 'success',
                        confirmButtonText: 'Aceptar'
                    });
                }, 2000);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }

        setCodigo('');
        setTipoFallaSeleccionado('');
        setObservaciones('');
        setOtrafalla('');
    };

    return (
        <div className={styles.container}>
            <header className={styles.header}>
                <h2 className={styles.title}><FaTools style={{ marginRight: '15px' }} /> Mantenimiento</h2>
                <p className={styles.subtitle}>Solicita soporte físico o reparaciones para tus equipos e instalaciones.</p>
            </header>

            {error && <div className="alert alert-danger">{error}</div>}

            <div className={styles.formCard}>
                <form onSubmit={handleSubmit} className={styles.formGrid}>
                    <div className={styles.inputGroup}>
                        {/* <label htmlFor="codigo" className={styles.label}>Código del Equipo</label> */}
                        <div className={styles.inputGroup}>
                            <label className={styles.label}>Buscar Equipo</label>

                            <input
                                type="text"
                                placeholder="Buscar por código o nombre..."
                                className={styles.select}
                                value={busquedaEquipo}
                                onChange={(e) => setBusquedaEquipo(e.target.value)}
                                required
                            />

                            {busquedaEquipo && (
                                <div style={{
                                    maxHeight: '200px',
                                    overflowY: 'auto',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '6px',
                                    marginTop: '5px',
                                    background: '#fff',
                                    position: 'relative',
                                    zIndex: 10
                                }}>
                                    {equipos.length === 0 ? (
                                        <div style={{ padding: '10px', color: '#64748b' }}>
                                            Cargando equipos...
                                        </div>
                                    ) : (
                                        equiposFiltrados.map((item) => {
                                            const eq = normalizeEquipo(item);
                                            return (
                                                <div
                                                    key={eq.id}
                                                    style={{
                                                        padding: '10px',
                                                        cursor: 'pointer',
                                                        borderBottom: '1px solid #f1f5f9'
                                                    }}
                                                    onClick={() => {
                                                        setCodigo(eq.cod);
                                                        setEquipoSeleccionado(eq);
                                                        setBusquedaEquipo(`${eq.cod} - ${eq.Nombrequipo}`);
                                                    }}
                                                >
                                                    <strong>{eq.cod}</strong> - {eq.Nombrequipo}
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className={styles.inputGroup}>
                        <label htmlFor="tipoFalla" className={styles.label}>Tipo de Falla</label>
                        <select
                            id="tipoFalla"
                            className={styles.select}
                            value={tipoFallaSeleccionado}
                            onChange={(e) => setTipoFallaSeleccionado(e.target.value)}
                            required
                        >
                            <option value="">Seleccionar tipo</option>
                            {tipofalla
                                .filter(falla => Number(falla.tipo) === 2)
                                .map((falla) => (
                                    <option key={falla.id} value={falla.id}>
                                        {falla.descripcion}
                                    </option>
                                ))}
                        </select>
                    </div>

                    {/* Campo "Especifique la falla" — aparece en fila completa cuando se elige Otra(s) */}
                    {(() => {
                        const fallaSeleccionada = tipofalla.find(
                            f => String(f.id) === String(tipoFallaSeleccionado)
                        );
                        const esOtra = fallaSeleccionada?.descripcion
                            ?.trim()
                            ?.toLowerCase()
                            ?.includes('otra');
                        return esOtra ? (
                            <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
                                <label className={styles.label} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                    <span style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '20px',
                                        height: '20px',
                                        background: 'linear-gradient(135deg, #f59e0b, #f97316)',
                                        borderRadius: '50%',
                                        color: 'white',
                                        fontSize: '0.7rem',
                                        fontWeight: '800'
                                    }}>↳</span>
                                    Especifique la falla
                                </label>
                                <input
                                    type="text"
                                    className={styles.select}
                                    value={otrafalla}
                                    onChange={(e) => setOtrafalla(e.target.value)}
                                    placeholder="Describa la falla manualmente..."
                                    required
                                    style={{
                                        borderColor: '#f59e0b',
                                        background: '#fffbeb',
                                        boxShadow: '0 0 0 3px rgba(245,158,11,0.1)'
                                    }}
                                />
                            </div>
                        ) : null;
                    })()}

                    <div className={`${styles.inputGroup} ${styles.fullWidth}`}>
                        <label htmlFor="observaciones" className={styles.label}>Descripción del Requerimiento</label>
                        <textarea
                            id="observaciones"
                            className={styles.textarea}
                            value={observaciones}
                            onChange={(e) => setObservaciones(e.target.value)}
                            rows={5}
                            placeholder="Describe detalladamente el problema o mejora requerida..."
                            required
                        />
                    </div>

                    <div className={`${styles.submitContainer} ${styles.fullWidth}`}>
                        <button type="submit" className={styles.submitButton}>
                            <FaPaperPlane /> Generar Ticket
                        </button>
                    </div>
                </form>
            </div>

            {loading && (
                <div className={styles.spinnerContainer}>
                    <PacmanLoader color="#f59e0b" loading={true} size={40} />
                </div>
            )}
        </div>
    );
};

export default GenerarTicketmto;
